<template>
    <div class="a-map-icon map-icon">
        <svg-icon
            original
            :name="`map-navigation/${direction}`"
            class="a-map-icon__icon"
        />
    </div>
</template>

<script>

export default {
    name: 'AMapIcon',
    props: {
        direction: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "a-map-icon";   
</style>